// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s-fleet-leasing__space-box[data-v-5a57d7d8] {
  margin-bottom: 20px;
}
.s-fleet-leasing__box[data-v-5a57d7d8] {
  width: 100%;
  height: unset;
  border-radius: 8px;
}
.s-fleet-leasing__box__title[data-v-5a57d7d8] {
  font-weight: 700;
  font-size: 20px;
}
.s-fleet-leasing__box__prices[data-v-5a57d7d8] {
  font-weight: 700;
  font-size: 20px;
  line-height: 22px;
}`, "",{"version":3,"sources":["webpack://./src/js/vue/apps/LeasingCompareSaverSlick.vue","webpack://./LeasingCompareSaverSlick.vue"],"names":[],"mappings":"AAEE;EACE,mBAAA;ACDJ;ADIE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;ACFJ;ADII;EACE,gBAAA;EACA,eAAA;ACFN;ADII;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;ACFN","sourcesContent":["\r\n.s-fleet-leasing {\r\n  &__space-box {\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  &__box {\r\n    width: 100%;\r\n    height: unset;\r\n    border-radius: 8px;\r\n\r\n    &__title {\r\n      font-weight: 700;\r\n      font-size: 20px;\r\n    }\r\n    &__prices {\r\n      font-weight: 700;\r\n      font-size: 20px;\r\n      line-height: 22px;\r\n    }\r\n  }\r\n}\r\n",".s-fleet-leasing__space-box {\n  margin-bottom: 20px;\n}\n.s-fleet-leasing__box {\n  width: 100%;\n  height: unset;\n  border-radius: 8px;\n}\n.s-fleet-leasing__box__title {\n  font-weight: 700;\n  font-size: 20px;\n}\n.s-fleet-leasing__box__prices {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 22px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
